import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { getData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';

import { SAL2040_R01Dto } from './Dto_SAL2040_R01';
import { SAL2040_R01Filter } from "./Store_SAL2040_R01";

const baseUrl = `${config.apiUrl}/SAL2040_R01`;

/**
 * 필터를 API 파라미터로 변환
 */
const getParams = (filter: Partial<SAL2040_R01Filter>, listLength?: number) => {
	return {
		compCd: filter.compCd || undefined,
		customCd: filter.customCd || undefined,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		itemCd: filter.itemCd || undefined,
		listLength: listLength || 0,
		refetchListLength: filter.refetchListLength || undefined
	};
};

/**
 * 영업 매출 내역 조회
 * @param option 조회 옵션 ('search', 'refetch' 또는 빈 문자열)
 * @param params 검색 조건
 * @param listLength 기존 목록 길이
 */
export const getSAL2040_R01List = async (
	option: string = '',
	params: Partial<SAL2040_R01Filter>,
	listLength: number = 0
) => {
	const url = option ? `${baseUrl}/${option}` : baseUrl;
	return await getData<ResponseDto<SAL2040_R01Dto[]>>(url, { params: getParams(params, listLength) });
};

/**
 * 영업 매출 내역 전체 개수 조회
 * @param params 검색 조건
 */
export const getSAL2040_R01AllCount = async (params: Partial<SAL2040_R01Filter>) => {
	const url = `${baseUrl}/allCount`;
	return await getData<ResponseDto<number>>(url, {
		params: getParams(params, 0)
	});
};

/**
 * 영업 매출 내역 엑셀 다운로드
 * @param option 조회 옵션 ('search' 또는 빈 문자열)
 * @param params 검색 조건
 */
export const downloadExcel_SAL2040_R01 = async (
	option: string = '',
	params: Partial<SAL2040_R01Filter>
) => {
	const url = option ? `${baseUrl}/excel/${option}` : `${baseUrl}/excel`;
	return await getData<ResponseDto<string>>(url, {
		params: getParams(params, 0)
	});
};

